/**
 * Specifies the direction of the message.
 * tag: 385
 * @readonly
 * @enum {string} (char)
 */
export enum MsgDirection {
  /** Receive */
  Receive = 'R',
  /** Send */
  Send = 'S',
}
